import {useCallback, useState} from 'react';

export interface DrawerFilterState {
	status: string[];
	priority: string[];
	assignee_id: string[];
	label_id: string[];
	requester_id: string[];
	created_after: string;
	created_before: string;
	updated_after: string;
	updated_before: string;
}

export const EMPTY_DRAWER_FILTERS: DrawerFilterState = {
	status: [],
	priority: [],
	assignee_id: [],
	label_id: [],
	requester_id: [],
	created_after: '',
	created_before: '',
	updated_after: '',
	updated_before: '',
};

export function useFilterDrawer() {
	const [isOpen, setIsOpen] = useState(false);
	const [draft, setDraft] = useState<DrawerFilterState>(EMPTY_DRAWER_FILTERS);

	const open = useCallback((currentFilters?: Partial<DrawerFilterState>) => {
		setDraft({...EMPTY_DRAWER_FILTERS, ...currentFilters});
		setIsOpen(true);
	}, []);

	const close = useCallback(() => {
		setIsOpen(false);
	}, []);

	const updateDraft = useCallback((partial: Partial<DrawerFilterState>) => {
		setDraft(prev => ({...prev, ...partial}));
	}, []);

	const clearDraft = useCallback(() => {
		setDraft(EMPTY_DRAWER_FILTERS);
	}, []);

	return {isOpen, draft, open, close, updateDraft, clearDraft};
}
